.empty-table{margin-bottom:3em}.current-submitted .current.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=current-problems-add-edit.component-PFG7PQBU.css.map */
